import './responsive.css';
import { ConfigProvider } from 'antd';
import ReactDOM from 'react-dom/client';
import { App } from './Components/app/App';
import React, { Suspense } from 'react';
import * as serviceWorker from './serviceWorker';
import { antdTheme, cssVariables } from './theme-lipu';

// Add CSS variables to document
const style = document.createElement('style');
style.innerHTML = cssVariables;
document.head.appendChild(style);

const container: any = document.getElementById('root');
const root = ReactDOM.createRoot(container);

root.render(
  <Suspense>
    <ConfigProvider
      theme={antdTheme}
      modal={{
        zIndex: 1060,
      }}
    >
      <App />
    </ConfigProvider>
  </Suspense>,
);

serviceWorker.unregister();
